import { Row, Col, Button } from "react-bootstrap";
import { default as React, useMemo } from "react";
import { Link } from "react-router-dom";
import { GenericTable } from "components/GenericTable";
import EditableCell from "containers/common/EditableCell";
import { createElementIdFactory, createReusableTableElementIds } from "utils/elementIds";
import { PAGE_SIZES } from "utils/pageSizeConfig";
import "containers/common/List.css";
import "containers/common/Table.css";

import {
    createColumnHelper,
} from "@tanstack/react-table";

function OwnerTreeList({
    data,
    controlType,
    saveRecord,
    updateTableState,
    propertyidlist,
    idList,
    parentChild,
}) {

    // --- TanStack Table Setup ---
    const tableData = data || [];
    const columnHelper = createColumnHelper();
    const createId = useMemo(() => createElementIdFactory("owner-tree-list"), []);
    const tableElementIds = useMemo(() => createReusableTableElementIds(createId), [createId]);

    const columns = [
        columnHelper.accessor("owner_tree_id", {
            id: "owner_tree_id",
            header: "ID",
            size: 60,
        }),
        columnHelper.accessor("owner_name", {
            id: "owner_name",
            header: "Name",
        }),
        columnHelper.accessor("sort_within", {
            id: "sort_within",
            header: "Sort Order",
            cell: EditableCell,
            size: 100,
        }),
        columnHelper.display({
            id: "actions",
            header: "",
            enableSorting: false,
            cell: ({ row, table }) => (
                <Button type="button" size="sm" variant="danger" onClick={() => table.options.meta.handleDelete({ row })}>
                    Delete
                </Button>
            ),
            size: 65,
        })
    ];

    // --- Render Functions ---
    function renderList(data) {
        if (!data || data.length === 0) return null;

        return (
            <table className="table table-borderless table-sm mt-1 plain-text-table">
                <tbody>
                    {data.map((d, i) => {
                        const targetId = parentChild === "subsidiary" ? d.owner_id_parent : d.owner_id_child;
                        const queryId = parentChild === "subsidiary" ? d.owner_id_child : d.owner_id_parent;

                        return (
                            <tr key={d.owner_id || i} style={{ borderBottom: '1px solid #f0f0f0' }}>
                                <td className="p-0">
                                    <Link
                                        to={`/owners/${targetId}?${parentChild}=${queryId}`}
                                        state={{ data: idList, propertyidlist: propertyidlist }}
                                        className="text-decoration-none d-block py-2 px-2"
                                        style={{ color: '#007bff' }}
                                    >
                                        <span style={{ fontSize: '0.95rem' }}>
                                            {d.sort_within + ") " + d.owner_name}
                                        </span>
                                    </Link>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        );
    }

    function renderComponent() {
        return (
            <div className="componentRendering">
                <Row className="show-Container">
                    <Col sm={12}>
                        {controlType === "table"
                            ? <GenericTable
                                columns={columns}
                                data={tableData}
                                section="owner-tree-list"
                                elementIds={tableElementIds}
                                pageSize={PAGE_SIZES.ownerDetailParentCompanyModalTable}
                                meta={{
                                    updateData: (rowIndex, columnId, value) => {
                                        updateTableState(rowIndex, columnId, value);
                                    },
                                    handleSave: async ({ row, value, column }) => {
                                        const recordToSave = {
                                            ...row.original,
                                            [column.id]: value
                                        };
                                        if (column.id === "owner_name" && (!value || value.trim() === "")) {
                                            return;
                                        }
                                        try {
                                            await saveRecord(recordToSave, 'tree', 'owner_tree_id');
                                        } catch (err) {
                                            console.error("Save failed:", err);
                                        }
                                    },
                                    handleDelete: async ({ row }) => {
                                        const record = row.original;
                                        const isTemp = record.new_record || String(record.owner_tree_id || '').includes('temp');
                                        if (window.confirm("Are you sure you want to delete this record?")) {
                                            if (isTemp) {
                                                const updatedData = tableData.filter(item => item.owner_tree_id !== record.owner_tree_id);
                                                updateTableState(updatedData, 'tree');
                                            } else {
                                                const archivedRecord = {
                                                    ...record,
                                                    archived: true,
                                                    archived_date: new Date().toISOString()
                                                };
                                                try {
                                                    await saveRecord(archivedRecord, 'tree', 'owner_tree_id');
                                                    const updatedData = tableData.filter(item => item.owner_tree_id !== record.owner_tree_id);
                                                    updateTableState(updatedData, 'tree');
                                                } catch (err) {
                                                    console.error("Archive failed:", err);
                                                    alert("Error archiving record.");
                                                }
                                            }
                                        }
                                    },
                                }}
                              />
                            : renderList(data)}
                    </Col>
                </Row>
            </div>
        );
    }
    return (
        <div className="OwnerTreeList">
            {renderComponent()}
        </div>
    );
}

export default OwnerTreeList;